var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('my-view',{attrs:{"PtGetOrderInfoToPay":_vm.PtGetOrderInfoToPay,"PtGetOrderPayFeeInfo":_vm.PtGetOrderPayFeeInfo,"PtPageOrderPay":_vm.PtPageOrderPay}})}
var staticRenderFns = []

export { render, staticRenderFns }